import { isValidLength } from 'helpers/utils/utils'
import { INPUT_LIMITS } from 'const/constants'
import { i18n } from 'strings/i18n'
import type { MobileErrors, SSNErrors } from 'strings/lang/translations.types'
import { getSSNError } from '../SecuredInstallmentsSignIn/SecuredInstallmentsUtils'

type inputFieldError = MobileErrors | SSNErrors | ''

export const getInputFieldError = (fieldError: inputFieldError) => {
  return fieldError
    ? i18n({
        paylaterSignIn: fieldError
      })
    : ''
}

export const getPhoneError = (phoneNumber: string) => {
  let error: MobileErrors | '' = ''
  if (phoneNumber.length === 0) {
    error = 'mobileEmptyError'
  } else if (!isValidLength(phoneNumber, INPUT_LIMITS.PHONE_NUMBER)) {
    error = 'mobileInvalidError'
  }
  return error
}

export const isFormValid = (phoneNumber: string, ssn: string): boolean => {
  return getPhoneError(phoneNumber) === '' && getSSNError(ssn) === ''
}
